export default __webpack_public_path__ + "static/media/indicator-high.449447aa.png";